import { render, staticRenderFns } from "./TAvatar.vue?vue&type=template&id=71931817&scoped=true&"
import script from "./TAvatar.vue?vue&type=script&lang=js&"
export * from "./TAvatar.vue?vue&type=script&lang=js&"
import style0 from "./TAvatar.vue?vue&type=style&index=0&id=71931817&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71931817",
  null
  
)

/* custom blocks */
import block0 from "./TAvatar.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports